type PredicateFunction<T> = (value: unknown) => value is T

export function createIsUnion<T>(values: readonly T[]): PredicateFunction<T> {
  return (value: unknown): value is T => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    return values.includes(value as T)
  }
}

export function createAssertType<T>(
  predicate: PredicateFunction<T>,
  typeName?: string
): (value: unknown) => T {
  return (value) => {
    if (predicate(value)) {
      return value
    }

    throw new TypeError(`${value} is not ${typeName ?? 'of desired type'}`)
  }
}

export function isRecord(val: unknown): val is Record<string, unknown> {
  if (typeof val !== 'object') return false
  if (!val) return false
  if (Array.isArray(val)) return false

  return true
}
